import React from 'react'
import useMobile from '../../hooks/useMobile'
import usePermission from '../../hooks/usePermission'
import { useSolarPlantList } from './hooks/useSolarPlantList'
import SolarPlantListDesktop from './components/SolarPlantListDesktop'
import SolarPlantListMobileView from './components/SolarPlantListMobileView'

const SolarPlantList = () => {
  const isMobile = useMobile()
  const logic = useSolarPlantList()
  const permissions = usePermission()

  if (isMobile) {
    return <SolarPlantListMobileView logic={logic} permissions={permissions} />
  }

  return <SolarPlantListDesktop logic={logic} permissions={permissions} />
}

export default SolarPlantList